<a class="product-card p-6 xl:p-5 rounded-2xl w-full h-full block" [ngClass]="{
        'one-shot-purchase': product.family == 'One shot purchase',
        'subscription': product.family == 'Subscription',
        'discount': isFeaturedProduct(),
    }" [routerLink]="productPath(false, product.productCode)">
    <div class="flex flex-col w-full h-full">
        <div class="flex flex-1 flex-col w-full">
            <div class="flex items-center justify-between gap-3">
                <span class="typology-text text-xs font-semibold uppercase tracking-[0.18em]">
                    {{ getProductTypeLabel() }}
                </span>
                @if (isFeaturedProduct()) {
                    <span class="badge-discount bg-secondary text-white py-1 px-3 rounded-3xl font-bold w-fit h-fit">
                        In evidenza
                    </span>
                }
            </div>
            <div *ngIf="product.imageUrl" class="product-card__image-frame mt-5">
                <img class="product-card__image" [src]="product.imageUrl" [alt]="product.name">
            </div>
            <div class="mt-5 flex flex-1 flex-col">
                <div class="title-container">
                    <h3 class="font-bold text-2xl title-text capitalize">{{ product.name }}</h3>
                </div>
                <p class="mt-3 subtitle-text">{{product.description}}</p>
            </div>
        </div>
        <div class="mt-8">
            <div class="flex items-center justify-between w-full">
                <div class="flex flex-col">
                    <div class="flex items-center price-text">
                        <span class="font-bold text-4xl">
                            @switch (product.family) {
                            @case ('Subscription') {
                            {{ product.price | currency: 'EUR':'symbol':(product.price % 1 == 0) ? '1.0-0' : '1.2-2' : 'it-IT' }}
                            }
                            @case ('One shot purchase') {
                            {{ product.price | currency: 'EUR':'symbol':(product.price % 1 == 0) ? '1.0-0' : '1.2-2' : 'it-IT' }}
                            }
                            }
                        </span>
                        <span class="text-base line-through ms-3" *ngIf="product.originalPrice">
                            {{ product.originalPrice | currency: 'EUR':'symbol':(product.originalPrice % 1 == 0) ? '1.0-0' : '1.2-2' : 'it-IT' }}
                        </span>
                    </div>
                    @if (product.originalPrice != null) {
                    <div class="mt-5">
                        <span class="text-sm font-bold bg-[#373536] px-2 py-1 text-white rounded-xl">Risparmi il {{ ((product.originalPrice - product.price) / product.originalPrice * 100) | number:'1.0-0' }}%</span>
                    </div>
                    }
                </div>
            </div>
        </div>
        <div class="mt-auto pt-8">
            <div class="flex items-center w-full">
                <span class="shop-text product-card__cta text-base font-bold">
                    <span class="flex items-center">
                        <span>{{ getProductCallToActionLabel() }}</span>
                        <svg class="size-4 ms-2">
                            <use href="../../../assets/svg/svGP.svg#chevron-right"></use>
                        </svg>
                    </span>
                </span>
            </div>
        </div>
    </div>
</a>
